import React from 'react';
import { PageHeader } from 'routes/layouts/pageHeader';
import { Heading } from '@chakra-ui/layout';
import { Box } from '@chakra-ui/react';

type FormHeaderProps = {
  previewMode: boolean;
  id: string | null;
};

export const FormHeader = ({
  previewMode,
  id,
}: FormHeaderProps): JSX.Element => {
  return (
    <PageHeader
      left={
        <Box alignItems="center" display="flex">
          <Heading as="h2" size="lg" mr={2}>
            {previewMode ? 'Ferðabeiðni' : 'Ný ferðabeiðni'}
          </Heading>
          {previewMode && (
            <Heading
              as="h2"
              size="lg"
              style={{ color: 'gray', fontSize: '1.5rem' }}
            >
              ({id})
            </Heading>
          )}
        </Box>
      }
    />
  );
};
